export interface ISeedAccessible {
  seed: any;
}

export function instanceOfISeedAccessible(instance: any): instance is ISeedAccessible {
  return instance
    && (instance.seed !== undefined);
}
